import { mergeConfig } from "./config.base";

export const config = mergeConfig({
  CLIENT_ID: "84d5c374-3d6a-404e-956a-42d386a50fbd",
  AUTH_URL: "https://identity-staging.inflosoftware.com",
  ENVIRONMENTS: [{ name: "Staging", url: "https://staging.inflosoftware.com/" }],
});
